module.exports = __webpack_public_path__ + "static/media/thermohug-logo.eaab6678.png";